import { Box, IconButton, Paper, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Tooltip, Typography } from '@mui/material';
import React from 'react'
import { useTypedSelector } from '../../../../store/hooks';
import TableToExcel from "@linways/table-to-excel";
import langFile from '../../../../data/lang.json';
import { theme } from '../../../../styles/theme';
import { getDateByGivenMonth } from '../../utils';

const InterestsSchedule: React.FC = () => {
    const { interests } = useTypedSelector(state => state.deposit);
    const { lang } = useTypedSelector(state => state.common);
    
    const downloadToExcel = () => {
        TableToExcel.convert(document.getElementById("interests-schedule"), {
            name: "schedule.xlsx",
            sheet: {
                name: "Sheet 1"
            }
        })
    }

    const Excel = () => {
        return (
            <svg style={{ width: 24, height: 24 }} viewBox="0 0 24 24">
                <path fill="#1D6F42" d="M14,2H6A2,2 0 0,0 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2M15.8,20H14L12,16.6L10,20H8.2L11.1,15.5L8.2,11H10L12,14.4L14,11H15.8L12.9,15.5L15.8,20M13,9V3.5L18.5,9H13Z" />
            </svg>
        )
    }

    return (
        interests.length > 0 ?
        <Box>
            <Stack 
                direction="row"
                justifyContent="space-between"
                alignItems="center"
                sx={{
                    pb: 1
                }}>
                <Typography variant="h6">{(langFile.interestSchedule as any)[lang]}</Typography>
                <Tooltip 
                    title={(langFile.download as any)[lang]}
                    placement="top">
                    <IconButton
                        onClick={downloadToExcel}>
                        <Excel/>
                    </IconButton>
                </Tooltip>
            </Stack>
            <TableContainer elevation={0} component={Paper}>
                <Table 
                    stickyHeader 
                    id="interests-schedule"
                    data-cols-width="10, 15, 20, 20">
                    <TableHead>
                        <TableRow
                            sx={{
                                '& th': {
                                    color: '#fff',
                                    background: theme.palette.primary.main,
                                    border: '1px solid rgba(224, 224, 224, 1)',
                                    py: .5
                                },
                            }}
                        >
                            <TableCell
                                data-b-a-s="thin"
                                data-a-h="center">{(langFile.period as any)[lang]}</TableCell>
                            <TableCell
                                data-b-a-s="thin"
                                data-a-h="center">{(langFile.tableDate as any)[lang]}</TableCell>
                            <TableCell
                                data-b-a-s="thin"
                                data-a-h="center">{(langFile.depositInterest as any)[lang]}</TableCell>
                            <TableCell
                                data-b-a-s="thin"
                                data-a-h="center">{(langFile.depositAmount as any)[lang]}</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {interests.map((row, index) => (
                            <TableRow
                                key={index}
                                sx={{
                                    '& td': {
                                        border: '1px solid rgba(224, 224, 224, 1)',
                                        py: 1
                                    },
                                }}
                            >
                                <TableCell
                                    data-t="n"
                                    data-b-a-s="thin"
                                    data-a-h="center">{row.period}</TableCell>
                                <TableCell
                                    data-b-a-s="thin"
                                    data-a-h="center">{getDateByGivenMonth(row.period).toLocaleDateString(lang === 'kz' ? 'ru' : lang)}</TableCell>
                                <TableCell
                                    data-b-a-s="thin"
                                    data-a-h="center">{row.interestSum.toLocaleString(lang === 'kz' ? 'ru' : lang)}</TableCell>
                                <TableCell
                                    data-b-a-s="thin"
                                    data-a-h="center">{row.amount.toLocaleString(lang === 'kz' ? 'ru' : lang)}</TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
        </Box> : 
        null
    )
}

export default InterestsSchedule;